//import Example from './example';
import Swipers from "./swiper";
jQuery(($) => {
    const swipers = new Swipers({});
    swipers.init();
});
